export const IMAGE_CACHE_NAME = 'marine-samraj-images-v1';
